import ProfileHeader from './profile_header'
import { connect } from 'react-redux'
import {
  getCampaignSelector,
  isMoneyPoolSelector,
} from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const isMoneyPool = isMoneyPoolSelector(state, props)

  return {
    backgroundImage: campaign.background_image,
    backgroundPan: campaign.background_pan,
    gradientColor: campaign.gradient_color,
    preview: campaign.preview,
    banner: state.personalizationStudio.banner,
    isLoggedIn: state.login_info && state.login_info.logged_in,
    isMoneyPool: isMoneyPool,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileHeader)
